import { ErrorResponseErrorItemCodeSubscription } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeSubscription, string> = {
  'subscription:url_not_whitelisted': "Url'n är inte vitlistad.",
  'subscription:not_found': 'Integrationen kunde inte hittas.',
};
